module.exports = __webpack_public_path__ + "static/media/ArrowUpIcon.277ccdf4.svg";